module.exports = __webpack_public_path__ + "static/media/icot1-dark.6a9a5eda.svg";